import React, { useState } from "react";
import { useRouter } from "next/router";
export default function ResponsievLine() {
  const router = useRouter();

  return (
    <div
      className={`sm:hidden block ${
        router.locale == "ar" ? "-scale-x-100" : ""
      } `}
    >
      <svg
        width="430"
        height="193"
        viewBox="0 0 430 193"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M507.571 24.232C475.662 11.0658 430.054 13.3394 398.858 33.005C351.537 62.835 331.404 124.83 253.011 159.675C173.06 195.212 99.142 148.393 -22.1439 178.098"
          stroke="url(#paint0_linear_602_9478)"
          stroke-width="30"
        />
        <defs>
          <linearGradient
            id="paint0_linear_602_9478"
            x1="202.478"
            y1="185.094"
            x2="203.348"
            y2="31.0609"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#2EBBFF" />
            <stop offset="0.5112" stop-color="#FE17FF" />
            <stop offset="1" stop-color="#6232EA" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
